import { merge } from 'lodash';
import { getBrandImage } from '../../utils/helper';

const baseCustomTheme = (theme, brandTheme) => {
  return merge(
    {
      Common: {
        textColor: theme.palette.common.black,
      },
      AppBar: {
        height: 70,
        logoImage: getBrandImage('logo.png'),
        logoHeight: 60,
        backgroundColor: 'transparent',
        scrolledBackgroundColor: theme.palette.common.white,
        boxShadow: 'inset 0 -1px 0 #e2e2ea',
        nonCompare: {
          logoImage: getBrandImage('logo.png'),
          logoHeight: 60,
          backgroundColor: theme.palette.common.white,
        },
        d2dStyles: {
          compare: {
            iconStyles: {
              color: theme.palette.primary.main,
            },
            textStyles: {
              color: theme.palette.grey['800'],
            },
          },
          nonCompare: {
            iconStyles: {
              color: theme.palette.primary.main,
            },
            textStyles: {
              color: theme.palette.grey['800'],
            },
          },
        },
      },
      CenteredPageCss: {
        marginTop: '70px',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        backgroundColor: theme.palette.primary.main,
        justifyContent: 'center',
      },
      ComparePlan: {
        postcodeHeadingOuter: {
          color: theme.palette.primary.dark,
        },
        postcodeHeading: {
          color: theme.palette.primary.main,
        },
      },
      PlanFilter: {
        extraPaddingTop: 0,
        background: theme.palette.common.white,
        filters: {
          menuButtonCss: {
            height: 44,
            cursor: 'pointer',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            borderRadius: theme.shape.borderRadius,
            boxShadow: 'none',
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.main,
            },
            borderColor: 'transparent',
            borderWidth: 0,
            borderStyle: 'solid',
            textAlign: 'left',
          },
          textCss: {
            textTransform: 'uppercase',
            fontSize: 16,
            fontWeight: 600,
            marginTop: '1px',
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.common.white,
          },
          iconCss: {
            color: theme.palette.common.white,
            fontSize: 20,
          },
          d2dCheckboxCss: {
            '.custom-checkbox': {
              color: theme.palette.primary.main,
              fontWeight: 700,
            },
            '.MuiFormControlLabel-label': {
              color: theme.palette.secondary.main,
              fontWeight: 400,
            },
          },
        },
        searchField: {
          helperTextCss: {
            '@media screen and (min-width: 600px)': {
              paddingLeft: theme.spacing(3),
            },
            fontWeight: 600,
            fontSize: 12,
            color: theme.palette.primary.main,
            display: 'inline-block',
          },
          buttonCss: {
            padding: `${theme.spacing(4.7, 5)} !important`,
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
            fontWeight: 600,
            fontSize: 20,
            textTransform: 'uppercase',
            '&:hover': {
              background: theme.palette.primary.main,
            },
            '&:disabled': {
              background: theme.palette.primary.main,
              opacity: 0.37,
              cursor: 'not-allowed',
            },
          },
          fieldCss: {
            borderColor: 'transparent',
            borderRadius: theme.shape.borderRadius,
            fontSize: 16,
            fontWeight: 400,
            backgroundColor: theme.palette.common.white,
            paddingTop: theme.spacing(0.6),
            paddingBottom: theme.spacing(0.6),
            '&:focus': {
              borderColor: theme.palette.primary.main,
            },
          },
          fieldIconCss: {
            color: theme.palette.primary.main,
            fontSize: 18,
          },
        },
      },
      BasicDetails: {
        BasicDetailsCss: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          '.MuiDialog-container &.has-promocode hr': {
            display: 'block',
          },
          '> *': {
            order: 2,
          },
          '.steps-content & hr': {
            display: 'none',
          },
          '.sidebar-right &': {
            h2: {
              fontSize: '19px',
              lineHeight: '21px',
            },
            '.price-details-rps': {
              marginBottom: '10px !important',
            },
            h3: {
              fontSize: '19px',
              lineHeight: '21px',
            },
            'price-details-estimated-cost': {
              marginBottom: '3px !important',
              h3: {
                marginBottom: 0,
              },
              p: {
                marginBottom: 0,
              },
            },
            h5: {
              fontSize: '13px',
              lineHeight: '15px',
              margin: 0,
            },
            '.basic-details__summary-bottom': {
              marginBottom: '10px !important',
            },
            hr: {
              margin: '6px 0 10px !important',
            },
            '.price-details': {
              marginTop: '0 !important',
            },
            '.estimated-cost-terms > p': {
              fontSize: '13px',
              lineHeight: '15px',
            },
          },
        },
        BasicDetailsTopCss: {
          '&.basic-details__summary-top': {
            // Added another class to make this more important without using !important
            order: 0,
          },
          '.basic-details__summary-heading': {
            textTransform: 'uppercase',
          },
          '.basic-details__summary-subheading': {
            fontSize: '16px',
          },
          BasicDetailsBottomCss: {},
        },
      },
      CompanyDetails: {
        SuccessField: {
          '&.success': {
            fieldset: {
              borderColor: theme.palette.success.light,
            },
            '.Mui-focused fieldset': {
              borderColor: theme.palette.success.main,
            },
            svg: {
              color: theme.palette.success.light,
            },
          },
        },
      },
      PlanDetailsCard: {
        PlanDetailsCardCss: {
          '&.has-promocode': {
            border: '2px solid ' + theme.palette.success.light,
          },
          '.MuiDialog-container &': {
            border: 'none',
          },
        },
        PlanFeatures: {
          backgroundColor: theme.palette.primary.selected,
          padding: '20px 30px',
          flexGrow: 1,
          '.icon-marker': {
            color:
              theme.palette?.miscellaneous?.planFeaturesIcon ||
              theme.palette.primary.main,
            marginTop: '2px!important',
          },
        },
        ServiceCardTopCss: {
          order: 0,
          padding: '30px 20px',
          '.MuiDialog-container &': {
            padding: 0,
          },
          '.has-promocode &': {
            paddingTop: '0',
          },
        },
        ServiceCardBottomCss: {
          padding: '0px 20px 30px 20px',
        },
        PromoMessageCss: {
          display: 'flex',
          justifyContent: 'center',
          margin: '0 -20px',
          marginBottom: 0,
          borderRadius: 0,
          textTransform: 'uppercase',
          textAlign: 'center',
          color: 'inherit',
          background: theme.palette.success.light,
          h5: {
            display: 'none',
          },
          h6: {
            fontWeight: 'bold',
            '.promo-message__terms': {
              fontWeight: '300',
              marginLeft: '3px',
            },
          },
          '.service-list-carousel &': {
            order: -1,
            '.MuiAlert-message': {
              width: '100%',
            },
            h4: {
              fontSize: '20px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            },
            'h4 span': {
              display: 'none',
            },
            h5: {
              display: 'block',
            },
            h6: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
            },
            'h6 .promo-message__description': {
              display: 'inline-block',
              maxWidth: 'calc(100% - 100px)',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            },
          },
          '.steps-content &': {
            order: 1,
            margin: '20px -30px',
          },
          '.MuiDialog-container &': {
            justifyContent: 'left',
            textAlign: 'left',
            margin: '0',
            marginTop: '24px',
            padding: '15px',
            'h4 span': {
              display: 'none',
            },
            h6: {
              fontSize: '12px',
            },
            '.promo-message__terms': {
              display: 'none',
            },
          },
          '.sidebar-right &': {
            padding: 0,
            marginTop: '5px',
            marginBottom: '10px',
            h4: {
              fontSize: '14px',
              lineHeight: '16px',
            },
            h6: {
              fontSize: '12px',
              lineHeight: '15px',
              fontWeight: '300',
              span: {
                display: 'block',
                marginTop: '8px',
              },
              '.promo-message__description': {
                display: 'none',
              },
            },
          },
        },
        PromoMessageTextCss: {
          color: 'inherit',
        },
      },
      PromoPopup: {
        PromoPopupLinkCss: {
          // Don't need button like styles just yet, but add inline-block and padding here to avoid movement when a promo is applied
          display: 'inline-block',
          padding: '10px 25px',
          color: 'inherit',
          cursor: 'pointer',
          '&.promo-applied': {
            backgroundColor: theme.palette.primary.main,
            borderRadius: '12px',
            fontWeight: 'bold',
            color: theme.palette.common.white,
            '.promo-applied__code': {
              marginRight: '5px',
            },
            svg: {
              marginLeft: '10px',
            },
          },
        },
        PromoPopupTextCss: {
          color: theme.palette.common.textColor,
        },
        buttonCss: {
          padding: '12px 20px !important',
        },
        Info: {
          fontStyle: 'italic',
          color: theme.palette.common.white,
        },
      },
      ReferDialog: {
        TermsCss: {
          textAlign: 'center',
          fontSize: 12,
          paddingTop: '10px',
          a: {
            color: 'inherit',
            textDecoration: 'underline',
          },
        },
        Whatsapp: {
          marginBottom: '10px',
          backgroundColor: '#25d366',
          marginRight: '5px',
          '&:visited': {
            backgroundColor: '#25d366',
          },
        },
        Viber: {
          marginBottom: '10px',
          backgroundColor: '#59267c',
          marginRight: '5px',
        },
        Facebook: {
          marginBottom: '10px',
          backgroundColor: '#316FF6',
          '&:visited': {
            backgroundColor: '#316FF6',
          },
        },
        Messenger: {
          marginBottom: '10px',
          backgroundColor: '#168AFF',
          '&:visited': {
            backgroundColor: '#168AFF',
          },
        },
      },
      FactSheet: {
        RadioGroup: {
          '& .MuiFormControlLabel-label': {
            minHeight: '48px', // same as .steps-container styles
          },
        },
        Tab: {
          background: theme.palette.secondary.light,
          marginTop: '15px',
        },
      },
      Footer: {
        logoImage: getBrandImage('logo.png'),
        logoHeight: 40,
      },
    },
    brandTheme
  );
};

export default baseCustomTheme;
